import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, getTopBetsService } from 'games/BottleManiaGame/balloonPumpGame.service'

const pickBets = (res) => {
  if (Array.isArray(res?.bets)) return res.bets
  if (Array.isArray(res?.rows)) return res.rows
  if (Array.isArray(res)) return res
  return []
}

export const getMyBets = createAsyncThunk('bottle-mania-game/myBets', async (params = { limit: 10, offset: 0 }, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return { bets: pickBets(res), offset: params.offset || 0 }
  } catch (error) {
    return thunkApi.rejectWithValue(error?.[0]?.description || error?.message)
  }
})

export const getTopBets = createAsyncThunk('bottle-mania-game/topBets', async (params = { limit: 10, offset: 0 }, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return { bets: pickBets(res), offset: params.offset || 0 }
  } catch (error) {
    return thunkApi.rejectWithValue(error?.[0]?.description || error?.message)
  }
})
